import React from "react"
import { Section, Card, Heading } from "components"
import { Typography, Steps, Carousel } from "antd"
import styled from "styled-components"
import { baseStyles } from "styles/base"
import { mobile, media } from "helpers"

const { Paragraph } = Typography

const StyledSection = styled(Section)`
	position: absolute;
	bottom: -120px;
	z-index: 10;
	left: 50%;
	transform: translateX(-50%);

	.ant-steps {
		.ant-steps-item {
			overflow: visible;
		}
		.ant-steps-item-container {
			overflow: hidden;
			.ant-steps-item-icon {
				background-color: ${baseStyles.primaryColor};
				.ant-steps-icon {
					color: #fff;
				}
			}
		}
	}

	.ant-carousel {
		.slick-dots {
			button {
				background: ${baseStyles.primaryColor};
			}
		}
	}

	${media.mobile`
		bottom: -150px;
		
		.ant-card {
			box-shadow: none;
		}
    `}
`

const TimeCost = styled.span`
	&& {
		position: absolute;
		right: 20px;
		top: -10px;
		font-size: 0.8em;
		z-index: 10;

		${media.mobile`
			top: -25px;
			right: 0;
			padding: 5px 10px;
			background: #ff9c01;
			border-radius: 0 0 5px 5px;
			color: #fff;
			z-index: 100;
		`}
	}
`

const introSteps = [
	{
		id: 1,
		title: "Find tutor",
		status: "finish",
		timeCost: "Up to 10 minutes",
		children: [{ title: "By subject" }, { title: "By curriculum" }],
	},
	{
		id: 2,
		title: "Qualify tutor",
		status: "finish",
		timeCost: "Up to 1 hour",
		children: [{ title: "By profile" }, { title: "By chat" }],
	},
	{
		id: 3,
		title: "Book tutor",
		status: "finish",
		timeCost: "Up to 24 hours",
		children: [{ title: "Bank transfer" }, { title: "Credit card" }, { title: "Installment" }],
	},
	{
		id: 4,
		title: "Start learning",
		status: "finish",
		timeCost: "",
		children: [{ title: "Online live lesson" }, { title: "Offline lesson" }],
	},
]

export default function IntroBlock() {
	return (
		<StyledSection width={mobile ? "100%" : "90%"} centered>
			<Paragraph strong type="secondary">
				Let us do the work for you to help you learn
			</Paragraph>
			{mobile ? (
				<Carousel>
					{introSteps.map((item) => (
						<Card height="140px" key={item.id}>
							<Steps current={null}>
								<Steps.Step
									title={item.title}
									status={item.status}
									description={
										<Paragraph type="secondary">
											<ul>
												{item.children.map((child) => (
													<li key={child.title}>{child.title}</li>
												))}
											</ul>
											{item.timeCost && <TimeCost>{item.timeCost}</TimeCost>}
										</Paragraph>
									}
								/>
							</Steps>
						</Card>
					))}
				</Carousel>
			) : (
				<Card autoheight="0">
					<Steps current={null}>
						{introSteps.map((item) => (
							<Steps.Step
								key={item.id}
								title={item.title}
								status={item.status}
								description={
									<Paragraph type="secondary">
										<ul>
											{item.children.map((child) => (
												<li key={child.title}>{child.title}</li>
											))}
										</ul>
										{item.timeCost && <TimeCost>{item.timeCost}</TimeCost>}
									</Paragraph>
								}
							/>
						))}
					</Steps>
				</Card>
			)}
		</StyledSection>
	)
}
